var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product_service_container"},[_c('p',{staticClass:"title"},[_vm._v("Anyhai-DTwin  V3.0")]),_c('p',{staticClass:"title2"},[_vm._v("专注于工业数字孪生服务")]),_c('p',{staticClass:"titl"},[_vm._v(" 工艺规划配置     漫游巡检     虚实联动     数字可视化 ")])])
}]

export { render, staticRenderFns }